<template>
    <div class="o-dashboardDelivery">
        <div v-if="addressesStatus === 'pending'">
                <a-icon icon="Spinner" />
        </div>
        <template v-else-if="addresses && addresses.length > 0">
            <div class="l-row l-row--center">
                <div class="l-row__column l-row__column--11">
                    <div class="o-dashboardDelivery__header a-mobile">
                        <div
                            class="o-dashboardDelivery__column o-dashboardDelivery__column--right"
                        >
                            <p class="a-label">Pokaż dostawy na adres</p>
                            <select
                                name="deliveryAddress"
                                class="a-select o-dashboardDelivery__select"
                                v-model="addressId"
                            >
                                <option
                                    v-for="address in addresses"
                                    v-bind:key="address.id"
                                    :value="address.id"
                                >
                                    {{ address.address }}
                                </option>
                            </select>
                        </div>
                        <div
                            v-if="calendarSummary
                                && Object.prototype.hasOwnProperty.call(calendarSummary, 'week_net')
                                && Object.prototype.hasOwnProperty.call(calendarSummary, 'month_net')
                            "
                            class="o-dashboardDelivery__column o-dashboardDelivery__column--left"
                        >
                            <p class="a-text a-text--big">
                                Koszt zamówionych dostaw:
                            </p>
                            <p class="a-price a-price--big a-price--left a-text--bold">
                                {{ calendarSummary.week_net.toPLN() }}&nbsp;<span class="a-label">/ 7 dni</span>
                            </p>
                            <p class="a-price a-price--left a-text">
                                {{ calendarSummary.month_net.toPLN() }}&nbsp;<span class="a-label a-text--bold">/ 1 mc</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="l-row l-row--center">
                <div class="l-row__column l-row__column--11">
                    <dashboard-calendar
                        class="a-mobile"
                        :month-deliveries="monthDeliveries"
                        @month-change="month = $event"
                        @delivery-cancel="fetchCalendar"
                        :calendar-status="calendarStatus"
                        :supported-days="supportedDays"
                        :address-id="addressId"
                    />
                </div>
            </div>
        </template>
        <div
            v-else
            class="l-row l-row--center"
        >
            <div class="l-row__column l-row__column--11">
                <p class="a-price a-price--left a-text--bold a-price--big">
                    Brak przypisanych adresów
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import DashboardCalendar from '@/components/dashboard/DashboardCalendar'
export default {
    components: {
        DashboardCalendar
    },
    data() {
        return {
            addressId: null,
            month: null,
            supportedDays: []
        }
    },
    computed: {
        addresses() {
            return this.$store.getters['companies/addresses']
        },
        addressesStatus() {
            return this.$store.getters['companies/addressesStatus']
        },
        monthDeliveries() {
            return this.$store.getters['deliveries/calendar']
        },
        calendarStatus() {
            return this.$store.getters['deliveries/calendarStatus']
        },
        calendarSummary() {
            return this.$store.getters['deliveries/calendarSummary']
        }
    },
    watch: {
        addressId() {
            this.fetchCalendar()
        },
        month() {
            this.fetchCalendar()
        }
    },
    methods: {
        fetchCalendar() {
            if(this.addressId !== null && this.month !== null) {
                // fetch availible days
                const selectedAddress = this.addresses.find(address => address.id === this.addressId)
                this.$store.dispatch('checkSupportedDays', {
                    geometry: {
                        lat: selectedAddress.latitude,
                        lng: selectedAddress.longitude
                    },
                    warehouse: {
                        id: selectedAddress.warehouse_id
                    },
                    // check all days
                    days: 0
                }).then(result => {
                    this.supportedDays = result
                })
                // fetch calendar
                this.$store.dispatch('deliveries/fetchCalendar', {
                    addressId: this.addressId,
                    month: this.month
                }).then(() => {
                    this.$store.dispatch('modalHide')
                })
            }
        }
    },
    created() {
        this.$store.dispatch('companies/fetchAddresses').then(() => {
            if(this.addresses.length > 0) {
                // set default address
                this.addressId = this.addresses[0].id
            }
        })
    }
}
</script>
